import breakfast0 from './Breakfast/breakfast1.png';
import breakfast1 from './Breakfast/breakfast2.png';
import breakfast2 from './Breakfast/breakfast3.png';
import breakfast3 from './Breakfast/breakfast4.png';
import breakfast4 from './Breakfast/breakfast5.png';
import breakfast5 from './Breakfast/breakfast6.png';
import lunch0 from './lunch/lunch1.png';
import lunch1 from './lunch/lunch2.png';
import lunch2 from './lunch/lunch3.png';
import lunch3 from './lunch/lunch4.png';
import lunch4 from './lunch/lunch5.png';
import lunch5 from './lunch/lunch6.png';
import dinner0 from './Dinner/dinner1.png';
import dinner1 from './Dinner/dinner2.png';
import dinner2 from './Dinner/dinner3.png';
import dinner3 from './Dinner/dinner4.png';
import dinner4 from './Dinner/dinner5.png';
import dinner5 from './Dinner/dinner6.png';

const fakeData = [
    {
        name: 'Bagel and Cream Cheese',
        image: breakfast0,
        price: 6.99,
        type: 'breakfast',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Breakfast Sandwitch',
        image: breakfast1,
        price: 9.99,
        type: 'breakfast',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Baked Chicken',
        image: breakfast2,
        price: 10.99,
        type: 'breakfast',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Egg Benedict',
        image: breakfast3,
        price: 8.99,
        type: 'breakfast',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Toast Corrisant Fried Egg',
        image: breakfast4,
        price: 19.99,
        type: 'breakfast',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Full Breakfast Fried Eggs',
        image: breakfast5,
        price: 15.99,
        type: 'breakfast',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Healty Meal Combo',
        image: lunch0,
        price: 23.99,
        type: 'lunch',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Fried Chicken Bento',
        image: lunch1,
        price: 9.99,
        type: 'lunch',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Tarragon Rubbed Salmon',
        image: lunch2,
        price: 6.99,
        type: 'lunch',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Indian Lunch',
        image: lunch3,
        price: 8.99,
        type: 'lunch',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Beef Steak',
        image: lunch4,
        price: 15.99,
        type: 'lunch',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Salmon with Peppers',
        image: lunch5,
        price: 7.99,
        type: 'lunch',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Salmon with Lentil Salad',
        image: dinner0,
        price: 9.99,
        type: 'dinner',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        title: 'Lemony Salmon Piccata',
        image: dinner1,
        price: 10.99,
        type: 'dinner',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Lamb Tenderloin',
        image: dinner2,
        price: 12.99,
        type: 'dinner',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'French Fries with Cheese',
        image: dinner3,
        price: 8.99,
        type: 'dinner',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Garlic Butter Baked Salmon',
        image: dinner4,
        price: 6.99,
        type: 'dinner',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    },
    {
        name: 'Baked Chicken',
        image: dinner5,
        price: 9.99,
        type: 'dinner',
        phrase: 'Love what you eat',
        description: `“The secret of success in life is to eat what you like and let the food fight it out inside.” 
        -Mark Twain`
    }
]

export default fakeData;